export const transactionHistoryMock = {
  commerce: {
    payment: {
      giftcard: {
        certificateTransactionHistory: {
          certificateBalance: 10,
          certificateExpirationDate: '2025-11-11',
          currency: 'USD',
          operatorMessage: null,
          pointsBalance: 0,
          totalRows: 1,
          transactionHistory: {
            edges: [
              {
                node: {
                  amount: '10.00',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '20.13',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '20',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '10.00',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '10.00',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '10.00',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '10.00',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '10.00',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
              {
                node: {
                  amount: '10.00',
                  certificateAmount: null,
                  channelID: null,
                  comments: null,
                  operator: null,
                  storeAmount: null,
                  storeCurrency: null,
                  storeName: 'Marriott International',
                  storeUser: null,
                  transactionActive: null,
                  transactionID: null,
                  transactionLocalDate: '2025-06-27T00:00:00.000Z',
                  transactionLocalTime: '02:48:47',
                  transactionRef: null,
                  transactionServerDatetime: null,
                  transactionType: 'Sale',
                  transactionTypeID: null,
                },
              },
            ],
          },
        },
      },
    },
  },
};
